import React from "react";
import { useLocation } from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

import { InputTextFieldMultiEquip } from "../Parts/InputText";
import { InputRadioEquip } from "../Parts/InputRadio";
import { InputDateMonthEquip } from "../Parts/InputDate";
import { DisplayField } from "../Parts/DisplayField";

import GenericTemplate from "../GenericTemplate";

const ESummry = () => {
  const location = useLocation();

  return (
    <GenericTemplate
      title="概要書"
      type={"建築設備"}
      selectedIndex={location.pathname}
    >
      <Box
        component="form"
        sx={{
          width: "100%",
          maxWidth: "100%",
        }}
        noValidate
        autoComplete="off"
      >
        <ESummry5 />
      </Box>
    </GenericTemplate>
  );
};

export default ESummry;

export const ESummry5 = React.memo(() => {
  return (
    <div>
      【5　不具合の発生状況】
      <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={2}>
          イ　不具合
        </Grid>
        <Grid item xs={10}>
          <InputRadioEquip key_num={"esummry5_i"}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={6}>
                <FormControlLabel value="有" control={<Radio />} label="有" />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel value="無" control={<Radio />} label="無" />
              </Grid>
            </Grid>
          </InputRadioEquip>
        </Grid>
      </Grid>
      <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={2}>
          ロ　不具合記録
        </Grid>
        <Grid item xs={10}>
          <InputRadioEquip key_num={"esummry5_ro"}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={6}>
                <FormControlLabel value="有" control={<Radio />} label="有" />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel value="無" control={<Radio />} label="無" />
              </Grid>
            </Grid>
          </InputRadioEquip>
        </Grid>
      </Grid>
      <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={2}>
          ハ　不具合の概要
        </Grid>
        <Grid item xs={10}>
          <DisplayField
            key_num={[
              "e3_1_12",
              "e3_1_22",
              "e3_1_32",
              "e3_2_12",
              "e3_2_22",
              "e3_2_32",
              "e3_3_12",
              "e3_3_22",
              "e3_3_32",
            ]}
            type={"Equipment"}
            bulding={`B1`}
            page={"e3"}
            label={"第三面から自動転記"}
          />
        </Grid>
      </Grid>
      <InputRadioEquip key_num={"esummry5_ni1"}>
        <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
          <Grid item xs={2} sx={{ mb: 1 }}>
            ニ　改善の状況
          </Grid>
          <Grid item xs={10} sx={{ mb: 1 }}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={4}>
                <FormControlLabel
                  value="実施済"
                  control={<Radio />}
                  label="実施済"
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  value="改善予定"
                  control={<Radio />}
                  label="改善予定"
                />
              </Grid>
              <Grid item xs={4}>
                <InputDateMonthEquip key_num1={"esummry5_ni2_1"} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ mb: 1, borderBottom: 1 }}
        >
          <Grid item xs={2} sx={{ mb: 3 }}></Grid>
          <Grid item xs={10} sx={{ mb: 3 }}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={4}>
                <FormControlLabel
                  value="予定なし"
                  control={<Radio />}
                  label="予定なし"
                />
              </Grid>
              <Grid item xs={8}>
                <InputTextFieldMultiEquip
                  key_num={"esummry5_ni3"}
                  label={"理由"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </InputRadioEquip>
    </div>
  );
});
